export enum Routes {
  ExpertInsights = 'expert_services/ongoing/expert_insights',
}
